import { del, get, post } from '@/utils/request';

/**
 * 登录
 */
export const login = <T>(data = {}) => {
  return post<T>('/auth/login', { data })
}

/**
 * 获取用户基本信息
 */
export const fetchUserInfo = <T>(data = {}) => {
  return post('/users/profile', { data })
}